// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__xur8s","flexContainer":"ProfileContent_flexContainer__2s5qY"};